import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { AssessorInvite } from 'containers/forms/assessors'
import { apiAssessors } from 'helpers/decorators/api'
import { meta, permissions, tableCommon } from 'helpers/decorators'
import AssessorsActivityTable from '../../../components/sections/assessors/AssessorsTable/AssessorsActivityTable'
import { connect } from 'react-redux'
import { modal } from '../../../redux/modules/app'

@meta({
  title: 'Assessors',
  intlKey: 'route.assessors'
})
@tableCommon()
@permissions()
@apiAssessors({
    loadAssessedActivities: true,
    filter: 'waitingActivityToAuthorizationAJ'
})
@connect(
    () => ({}),
    { modal }
)
class AssessorsWaitingActivityAuthorizationAJ extends Component {
  static propTypes = {
    inviteAssessor: PropTypes.func.isRequired
  }

  render () {
    return (
      <div>
        <div>
          <AssessorInvite inviteAssessor={this.props.inviteAssessor} />
{/*            <FilterAssessorActivities />*/}
          <AssessorsActivityTable {...this.props} isBecomeAssessor={true} />
        </div>
      </div>
    )
  }
}

export default AssessorsWaitingActivityAuthorizationAJ
